import {lazy, Suspense, useMemo} from "react";
import useAuth from "utils/hooks/useAuth";
import {useSelector} from "react-redux";
import {Loading} from "../shared";
const layouts = {
    admin: lazy(() => import('./AdminLayout')),
    user: lazy(() => import('./UserLayout')),
}
export default function Layout() {
    const { authenticated } = useAuth()

    const layoutType = useSelector((state) => state.base.common.layout.type)
    const loading = useSelector((state) => state.base.common.loading)

    const AppLayout = useMemo(() => {
        if (layoutType === 'admin') {
            if (authenticated) {
                return layouts[layoutType]
            }
            return lazy(() => import('./AuthLayout'))
        }
        return layouts[layoutType]
    }, [authenticated, layoutType])

    return (
        <Suspense
            fallback={
                <div className="flex flex-auto flex-col h-[100vh]">
                    <Loading type='cover' loading={true} />
                </div>
            }
        >
            <Loading type='cover' loading={loading.length > 0}>
                <AppLayout />
            </Loading>
        </Suspense>
    )
}